import React, { Component } from "react";
import FakeData from ".././fake-data";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import {
	View
} from 'react-native'
import { Helmet } from "react-helmet";
import "./Profile.css";
import {
	BannerReportView
} from './Admin';
import {
	ChangePictureIcon,
	ConfirmModal,
	BannerShimmer,
	AngularTemplateView,
	EmptyState,
	LoadingState,
	PostItem,
	GlobalTMFeeds,
	GlobalTMForm,
	LeagueSplitView,
	SetTournGameModal,
	ItemPicker,
	Modal,
	ComboBox,
	PhotoAddModal,
	TagView,
	MomentPickerModal,
	EditGameModal,
	PlayOffView,
	FeedBackPopUp
} from ".././components/Common";

import EventView from ".././components/Event";
import AboutView from ".././components/About";
import Friends from ".././components/Friends";
import Photos from ".././components/Photos";
import Videos from ".././components/Videos";
import Games from ".././components/Games";
import Settings from ".././components/Settings";
import Training from ".././components/Training";
import InternalNoticeCenter from ".././components/InternalNoticeCenter";
import WithSettings from "../components/withSettings";
import Redirect from "react-router-dom/Redirect";

const Trojan = window.Trojan;
const Croppie = window.Croppie;
const $ = window.$;
const jQuery = window.jQuery;

export default class Profile extends Component {
	constructor(props) {
		super(props);
		this.state = {
			id: this.props.match.params.teamId,
			user: { id: null },
			error: false,
			isParent: false,
			activeTab: "about",
			tabs: [
				{ val: "timeline", key: "Timeline", notices: [] },
				{ val: "games", key: "Games", notices: [] },
				{ val: "about", key: "About", notices: [] },
				{ val: "friends", key: "Friends", notices: [] },
				{ val: "photos", key: "Photos", notices: [] },
				{ val: "videos", key: "Videos", notices: [] },
				{ val: "training", key: "Training", notices: [] },
				{ val: "events", key: "Events", notices: [] },
				{ val: "notice", key: "Notifications", notices: [] },
				{ val: "settings", key: "Settings", notices: [] }
			],
			offset: 0,
			posts: [],
			isLoadingPosts: true,
			events: [],
			yourPhotos: [],
			photosOfYou: [],
			albums: [],
			yourVideos: [],
			videosOfYou: [],
			limit: 30,
			sessions: [],
			sessionFiles: []
		};

		this.onScroll = this.onScroll.bind(this);
		this.setTab = this.setTab.bind(this);
		this.onPostAdded = this.onPostAdded.bind(this);
	}

	componentWillMount() {
		const s = new Trojan.style("league").kill();
		FakeData.mountState("profile", true);
	}

	componentDidMount() {
		window.addEventListener("scroll", this.onScroll);
		this._isMounted = false;
		const _that = this;

		const _type = "F"
		const _list = FakeData.getBlocked({ props: {} }, true, [_type]);
		const system = _list.BlockedBySystem.filter((item, i) => {
			return (item.username === this.props.match.params.id || item.user_id === this.props.match.params.id) && item.user_type === _type;
		})

		const by_you = _list.BlockedByYou.filter((item, i) => {
			return (item.username === this.props.match.params.id || item.user_id === this.props.match.params.id) && item.user_type === _type;
		})

		const for_you = _list.BlockedForYou.filter((item, i) => {
			return (item.username === this.props.match.params.id || item.user_id === this.props.match.params.id) && item.user_type === _type;
		})

		const final_array = system.concat(for_you, by_you);
		const username_array = [];
		final_array.forEach((item, i) => {
			username_array.push(item.username)
			username_array.push(item.user_id)
		})

		const _isBlocked = (FakeData.inArray(this.props.match.params.id, username_array)) ? true : false;
		if (_isBlocked) {
			_that.setState({
				error: true,
				user: { error: true }
			});
		} else {
			if (this.props.match.params.id === FakeData.getData("yoo").username) {
				this.setState({ user: FakeData.getData("yoo") });
			}
			setTimeout(() => {
				_that.getProfile();
				//_that.getPosts()
				_that.getEvents();
				_that.getYourPhotos();
				_that.getPhotosOf();
				_that.getVideoOf();
				_that.getYourVideos();
				_that.getSessions();
				var params = FakeData.getQueries(_that.props.location.search);
				_that.setState({ activeTab: params.sInit ? params.sInit : "about" });
			}, 1000);

			document.querySelector("#root").addEventListener("scroll", this.onScroll);
		}
		//console.log(this.props)
	}

	componentWillUnmount() {
		this._isMounted = false;
		const s = new Trojan.style("league").kill();
		FakeData.mountState("profile", false);
		//window.removeEventListener('scroll', this.onScroll);

		document
			.querySelector("#root")
			.removeEventListener("scroll", this.onScroll);
	}

	initService = () => {
		const { EventSource } = window;
		if (EventSource) {
			this.system = new EventSource(
				FakeData.fetchURL +
				"/getUserProfile.php?auth0&id=" +
				FakeData.getData("yoo").username +
				"&them=" +
				this.props.match.params.id +
				"&profile_update"
			);
			const _that = this;
			if (this.system !== null) {
				//this.system.addEventListener()
				this.system.onmessage = function (e) { };

				this.system.addEventListener(
					"open",
					function (e) {
						// Connection was opened.
						//console.log(e)
					},
					false
				);

				this.system.addEventListener(
					"profile_update",
					function (e) {
						// Connection was opened.
						if (_that._isMounted) {
							const res = JSON.parse(e.data);
							_that.state.tabs[8].notices = _that.getUnreadNotices(res.notices);
							const _user = res;
							_user.type = "P";
							FakeData.setData("user", _user);
							var params = FakeData.getQueries(_that.props.location.search);
							_that.setState({
								user: res,
								tabs: _that.state.tabs
							});
						}
					},
					false
				);

				this.system.addEventListener(
					"error",
					function (e) {
						if (e.readyState == EventSource.CLOSED) {
							// Connection was closed.
						}
					},
					false
				);
			}
		} else {
			console.warn("EventSource Streams not supoorted by browser");
			this.getProfile();
		}
	};

	setTab(item) {
		this.setState({
			activeTab: item.val
		});
	}

	getProfile() {
		const _that = this;
		const dataTo = {
			user: FakeData.getData("yoo"),
			teamId: this.props.match.params.id
		};

		FakeData.post(
			"/getUserProfile.php?auth0&id=" +
			FakeData.getData("yoo").username +
			"&them=" +
			this.props.match.params.id,
			{},
			{
				success: res => {
					if (!FakeData.isMounted("profile")) {
						return;
					}
					if (res.error && this.state.user.id == null) {
						_that.setState({
							error: true,
							user: _that.state.user.id == null?res:_that.state.user
						});
					} else {
						_that.state.tabs[8].notices = _that.getUnreadNotices(res.notices);
						const _user = res;
						let isAdmin = res.isAdmin;
						let isParent = false;
						if (res.age < 16 && res.parents.length > 0) {
							const parents = res.parents.filter((p, i) => {
								return p.user.id === FakeData.getData("yoo").id;
							});
							isAdmin = parents.length > 0 ? true : res.isAdmin;
							isParent = parents.length > 0 ? true : false;
						}

						res.isAdmin = isAdmin;

						_user.type = "P";
						FakeData.setData("user", _user);
						var params = FakeData.getQueries(_that.props.location.search);
						_that.setState({
							user: res,
							tabs: _that.state.tabs,
							isParent: isParent
						});

						//FakeData.setTitle((!res.name)?"Profile":res.name+"'s Profile")
					}
					FakeData.setData("user", res);
					_that.getProfileID = setTimeout(() => {
						_that.getProfile();
					}, 5000);
				},
				error: err => {
					_that.setState({
						error: true,
						user: { error: true }
					});
				}
			}
		);
	}

	getPosts() {
		const _that = this;
		const dataTo = {
			user: FakeData.getData("yoo"),
			userTo: {
				id: this.state.user.id,
				type: ""
			},
			clubs: [],
			leagues: [],
			teams: [],
			limit: this.state.limit
		};

		FakeData.post("/getPosts.php?auth0", dataTo, {
			success: res => {
				if (!FakeData.isMounted("profile")) {
					return;
				}
				_that.setState({
					posts: res,
					isLoadingPosts: false
				});

				_that.getPostsID = setTimeout(() => {
					// _that.getPosts()
				}, 1000);
			},
			error: err => { }
		});
	}

	getEvents() {
		const _that = this;
		const dataTo = {
			userId: FakeData.getData("yoo").id,
			userToId: this.state.user.id,
			userToType: "F",
			teamIds: []
		};

		FakeData.post("/getEvents.php?auth0", dataTo, {
			success: res => {
				if (!FakeData.isMounted("profile")) {
					return;
				}
				res.sort(function (a, b) {
					return b.timestamp - a.timestamp;
				});
				_that.setState({
					events: res
				});

				setTimeout(() => {
					_that.getEvents();
				}, 10000);
			},
			error: err => { }
		});
	}

	getYourPhotos() {
		const _that = this;
		const dataTo = {
			user: FakeData.getData("yoo"),
			userTo: {
				id: this.state.user.id,
				type: "F"
			}
		};

		FakeData.post("/getPhotos.php?auth0&yours", dataTo, {
			success: res => {
				if (!FakeData.isMounted("profile")) {
					return;
				}

				//console.log(res)
				_that.setState({
					yourPhotos: res
				});

				FakeData.setData("user_photos", res);

				setTimeout(() => {
					_that.getYourPhotos();
				}, 3000);
			},
			error: res => {
				setTimeout(() => {
					_that.getYourPhotos();
				}, 3000);
			}
		});
	}

	getPhotosOf() {
		const _that = this;
		const dataTo = {
			user: FakeData.getData("yoo"),
			userTo: {
				id: this.state.user.id,
				type: "F"
			}
		};

		FakeData.post("/getPhotos.php?auth0", dataTo, {
			success: res => {
				if (!FakeData.isMounted("profile")) {
					return;
				}
				_that.setState({
					photosOfYou: res
				});

				setTimeout(() => {
					_that.getPhotosOf();
				}, 15000);
			},
			error: res => {
				setTimeout(() => {
					//_that.getPhotosOf()
				}, 3000);
			}
		});
	}

	getYourVideos() {
		const _that = this;
		const dataTo = {
			user: FakeData.getData("yoo"),
			userTo: {
				id: this.state.user.id,
				type: "F"
			}
		};

		FakeData.post("/getVideos.php?auth0&yours", dataTo, {
			success: res => {
				if (!FakeData.isMounted("profile")) {
					return;
				}
				_that.setState({
					yourVideos: res
				});

				FakeData.setData("user_photos", res);

				setTimeout(() => {
					_that.getYourVideos();
				}, 10000);
			},
			error: res => {
				setTimeout(() => {
					//_that.getYourVideos()
				}, 3000);
			}
		});
	}

	getVideoOf() {
		const _that = this;
		const dataTo = {
			user: FakeData.getData("yoo"),
			userTo: {
				id: this.state.user.id,
				type: "F"
			}
		};

		FakeData.post("/getVideos.php?auth0", dataTo, {
			success: res => {
				if (!FakeData.isMounted("profile")) {
					return;
				}
				_that.setState({
					videosOfYou: res
				});

				setTimeout(() => {
					_that.getVideoOf();
				}, 15000);
			},
			error: res => {
				setTimeout(() => {
					_that.getVideoOf();
				}, 3000);
			}
		});
	}

	onScroll(e) {
		this.setState({
			offset: document.querySelector("#root").scrollTop
		});
	}

	onPostAdded(post) {
		//console.log(this.state.posts.length);
		this.state.posts.unshift(post);
		this.setState({
			posts: this.state.posts
		});

		//console.log(this.state.posts.length);
	}

	getUnreadNotices = notices => {
		const list = [];
		FakeData.listify(notices).forEach((item, i) => {
			if (item.context.status === "unread") {
				list.push(item);
			}
		});

		return list;
	};

	getSessions = () => {
		const _that = this;
		const dataTo = {
			user: FakeData.getData("yoo"),
			userTo: {
				id: this.state.user.id,
				type: "F"
			}
		};

		FakeData.post("/getSessions.php?auth0", dataTo, {
			success: res => {
				if (!FakeData.isMounted("profile")) {
					return;
				}
				_that.setState({
					sessions: res
				});

				setTimeout(() => {
					_that.getSessions();
				}, 15000);
			},
			error: res => {
				setTimeout(() => {
					_that.getSessions();
				}, 3000);
			}
		});
	};

	getTeamIds = () => {
		const teams = FakeData.listify(this.state.user.myTeams);
		const list = [];
		teams.forEach((item, i) => {
			list.push(item.id);
		});

		return list;
	};

	getSettingValue = (tag, cat, type, fallbackValue) => {
		const settings = this.props.profileSettings.filter((item, i) => {
			return (
				item.cat === cat &&
				item.type === type &&
				FakeData.inArray(item.sub, tag.split(","))
			);
		});

		if (settings.length === 0) {
			return fallbackValue;
		} else {
			return settings[0]["value"];
		}
	};

	render() {
		if (this.state.user.id == null && !this.state.user.error) {
			return <BannerShimmer />;
		}

		if (this.state.user.error) {
			return (
				<Redirect to={{
					pathname: "/account_error",

				}} />
			)
		}

		return (
			<div
				className="tabs team row main_content sp-flex-width"
				style={{ zIndex: 0, padding: "10px 10px" }}
			>
				<Helmet
					title={this.state.user.name}
					meta={[
						{ name: "description", content: "Description of page" },
						{ property: "og:type", content: "profile" },
						{ property: "og:title", content: this.state.user.name },
						{ property: "og:image", content: this.state.user.image },
						{
							property: "og:url",
							content:
								FakeData.baseURL +
								"/#" +
								this.props.location.pathname +
								this.props.location.search
						}
					]}
				/>
				<ProfileBanner
					isParent={this.state.isParent}
					BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou}
					pictures={this.state.yourPhotos}
					profile={this.state.user}
					tabs={this.state.tabs}
					activeTab={this.state.activeTab}
					onTabSelect={this.setTab}
				/>
				{this.state.activeTab != "training" &&
					this.state.activeTab != "events" && (
						<LeagueSplitView
							isUser={true}
							BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou}
							profile={this.state.user}
							class="league"
							offset={this.state.offset}
						>
							{this.state.activeTab == "timeline" && (
								<div>
									<GlobalTMForm
										BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou}
										profile={this.state.user}
										words={() => {
											const _settings = FakeData.listify(
												this.state.user.settings
											).filter((set, i) => {
												return set.sub === "word_restrition";
											});

											if (_settings[0]) {
												return FakeData.nullify(_settings[0]["value"]).split(
													","
												);
											} else {
												return [];
											}
										}}
										user={
											this.state.user
												? this.state.user
												: FakeData.getData("yoo")
										}
										userType={this.state.user.isAdmin ? "F" : "F"}
										isAdmin={this.state.user.isAdmin}
										onPostAdded={this.onPostAdded}
										postToType="F"
										postToId={this.state.user.id}
										postToName={this.state.user.name}
										postToImage={this.state.user.image}
									/>
									<GlobalTMFeeds
										profile={this.state.user}
										BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou}
										postToType="F"
										words={() => {
											const _settings = FakeData.listify(
												this.state.user.settings
											).filter((set, i) => {
												return set.sub === "word_restrition";
											});

											if (_settings[0]) {
												return FakeData.nullify(_settings[0]["value"]).split(
													","
												);
											} else {
												return [];
											}
										}}
										page={{ id: this.state.user.id, type: "F" }}
										teams={[]}
										clubs={[]}
										leagues={[]}
										institutions={[]}
										user={this.state.user}
										userType={this.state.user.isAdmin ? "F" : "F"}
										posts={this.state.posts}
									>
										<EmptyState
											style={{ background: "#fff" }}
											isShown={
												FakeData.listify(this.state.posts).length === 0 &&
													!this.state.isLoadingPosts
													? true
													: false
											}
											text="No posts were found!"
											icon="filter_hdr"
										/>
										<LoadingState
											style={{ background: "#fff" }}
											isShown={this.state.isLoadingPosts}
											text={"Loading"}
										/>
									</GlobalTMFeeds>
								</div>
							)}
							{this.state.activeTab == "games" && (
								<Games BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} teams={this.getTeamIds()} league={false} />
							)}
							{this.state.activeTab == "about" && (
								<div>
									<AboutView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={this.state.user} type="P" state="user" />
								</div>
							)}
							{this.state.activeTab == "videos" && (
								<Videos
									user={
										this.state.user ? this.state.user : FakeData.getData("yoo")
									}
									BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou}
									userType={this.state.user.isAdmin ? "F" : "F"}
									author={this.state.user.name}
									data={{
										uploads: this.state.yourVideos,
										tagged: this.state.videosOfYou
									}}
									isAdmin={this.state.user.isAdmin}
								/>
							)}
							{this.state.activeTab == "photos" && (
								<Photos
									user={
										this.state.user ? this.state.user : FakeData.getData("yoo")
									}
									BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou}
									userType={this.state.user.isAdmin ? "F" : "F"}
									author={this.state.user.name}
									data={{
										uploads: this.state.yourPhotos,
										tagged: this.state.photosOfYou,
										albums: this.state.albums
									}}
									isAdmin={this.state.user.isAdmin}
								/>
							)}
							{this.state.activeTab == "friends" && (
								<Friends
									username={this.state.user.username}
									teams={this.getTeamIds()}
									BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou}
									profile={this.state.user}
									isAdmin={this.state.user.isAdmin}
								/>
							)}
							{this.state.activeTab == "notice" && (
								<InternalNoticeCenter
									notices={this.state.user.notices}
									profile={this.state.user}
									type={"F"}
									BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou}
								/>
							)}
							{this.state.activeTab == "settings" && (
								<Settings profile={this.state.user} type="F" state="user" />
							)}
						</LeagueSplitView>
					)}

				{this.state.activeTab == "training" && (
					<Training
						sessions={this.state.sessions}
						files={this.state.sessionFiles}
						user={this.state.user}
						BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou}
						userType={"F"}
					/>
				)}

				{this.state.activeTab == "events" && (
					<EventView
						viewEvents={true}
						eventToType="F"
						eventToID={this.state.user.id}
						events={this.state.events}
						profile={this.state.user}
						BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou}
					/>
				)}
			</div>
		);
	}
}

class ProfileBanner extends Component {
	constructor(props) {
		super(props);
		const request = this.inYourRequests(props.profile.id);
		this.state = {
			activeTab: "details",
			activeIndex: 0,
			isFriend: props.profile.isFriend,
			isPending: props.profile.isPending,
			activeTeam: null,
			isDeleting: false,
			cancelID: props.profile.your_req_id,
			request
		};
	}

	getSportGoalTerm(name) {
		const term =
			name === "Rugby" ? "Tries" : name === "Cricket" ? "Runs" : "Goals";
		return term;
	}

	getTeams(sport, teams) {
		const arr = [];
		teams.forEach((item, i) => {
			if (item.sport === sport) {
				arr.push(item);
			}
		});

		return arr;
	}

	setStyle(style) {
		const s = new Trojan.style("league").declare(style).run();
	}

	getFilteredNotices = (arr, data) => {
		const list = [];
		FakeData.listify(data).forEach((item, i) => {
			if (FakeData.inArray(item.actionData.context, arr)) {
				list.push(item);
			}
		});

		return list;
	};

	remove() {
		const them = this.props.profile;
		const _that = this;
		const _you = them.friends.filter((item, i) => {
			return item.id === FakeData.getData("yoo").id;
		});
		console.log(_you);

		const dataTo = {
			id: _you[0] ? _you[0].rawId : false
		};

		if (!dataTo.id) {
			return;
		}

		FakeData.post(
			"/deleteRelationship.php?auth0",
			dataTo,
			{
				success: res => {
					_that.setState({
						isDeleting: false,
						isPending: false,
						isFriend: false
					});
					FakeData.alert("Done!");
				},
				error: err => { }
			},
			true,
			"",
			res => { }
		);
	}

	cancelRequest = (id = false) => {
		const _that = this;
		const dataTo = {
			id: id ? id : this.state.cancelID
		};

		if (!dataTo.id) {
			return;
		}

		FakeData.post(
			"/deleteRelationship.php?auth0",
			dataTo,
			{
				success: res => {
					_that.setState({
						isDeleting: false,
						isPending: false,
						isFriend: false,
						request: {
							inRequest: false,
							yourCancelID: false,
							data: false
						}
					});
					FakeData.alert("Done!");
				},
				error: err => { }
			},
			true,
			"",
			res => { }
		);
	};

	addFriend() {
		const _that = this;
		const dataTo = {
			user: FakeData.getData("yoo"),
			data: {
				user: this.props.profile,
				type: "friends",
				privacy: 1,
				tag: "friends"
			}
		};

		FakeData.post(
			"/addRelationShip.php?auth0",
			dataTo,
			{
				success: res => {
					_that.setState({
						isPending: true,
						isFriend: false,
						cancelID: res.id
					});

					FakeData.alert("Done!");
				},
				error: err => { }
			},
			true,
			"",
			res => { }
		);
	}

	acceptThem = () => {
		const _that = this;
		const notice = this.state.request.data
		const data = {
			id: notice.actionData.contextId,
			user: notice.user,
			userTo: notice.otherUser,
			status: "declined",
			noticeId: notice.id
		};

		FakeData.post(
			"/acceptRelationship.php?auth0",
			data,
			{
				success(r) {
					FakeData.alert("Done!");
					_that.setState({
						isFriend: true, request: {
							inRequest: false,
							yourCancelID: false,
							data: false
						}
					});
					if (_that.props.unMountedCallBack) {
						_that.props.unMountedCallBack.call(this);
					}
				},
				error(r) {
					FakeData.alert("Couldn't reached server!");
					//_that.setState({ isOpen: false });
					if (_that.props.unMountedCallBack) {
						_that.props.unMountedCallBack.call(this);
					}
				}
			},
			true,
			"",
			() => { }
		);
	};

	inYourRequests = id => {
		const _yourRequests = FakeData.getData("yoo").relations;
		const _list = _yourRequests.filter((item, i) => {
			return item.otherUser.id;
		});

		return _list.length > 0
			? {
				inRequest: true,
				yourCancelID: _list[0].actionData.contextId,
				data: _list[0]
			}
			: {
				inRequest: false,
				yourCancelID: false,
				data: false
			};
	};

	settings = () => {
		const _ = FakeData.___("F", {}, this.props.profile, []);

		return _;
	}

	render() {
		const yoo = FakeData.getData("yoo");
		const them = this.props.profile;
		const _settings = this.settings()
		const sports = FakeData.getData("all_sports")
			? FakeData.getData("all_sports")
			: [];
		const teams =
			this.state.activeTab !== "details"
				? []
				: them.mySport[this.state.activeIndex]
					? this.getTeams(
						them.mySport[this.state.activeIndex].name,
						them.myTeams
					)
					: [];
		return (
			<div
				className="profile-banner sp-flex-width"
				style={{ zIndex: 0, height: "420px", position: "relative", overflowY: 'hidden' }}
			>
				{them.isAdmin &&
					<BannerReportView id={them.id} type={'F'} />
				}
				<img
					key={them.id}
					crossOrigin={"supotsu.com"}
					src={
						them.bg_image !== FakeData.apiURL+"/"
							? them.bg_image
							: "images/player_profile_cover.jpg"
					}
					onLoad={e => {
						//console.log(e.target,window.Vibrant)
						try {
							var vibrant = new window.Vibrant(e.target);
							var swatches = vibrant.swatches();
							for (var swatch in swatches) {
								if (
									swatches.hasOwnProperty(swatch) &&
									swatches[swatch] &&
									swatch === "Vibrant"
								) {
									//console.log(swatch, swatches[swatch].getHex(), swatches[swatch].getTitleTextColor())
									const style = FakeData.getProfileStyle(
										swatches[swatch].getHex(),
										swatches[swatch].getTitleTextColor(),
										swatches[swatch].getBodyTextColor()
									);
									//console.log(style)
									this.setStyle(style);
									break;
								}
							}
						} catch (error) {
							console.log(error);
						}
					}}
				/>
				<div className="profile-banner-main">
					<div className="profile-banner-main-hero">
						<div className="top-section">
							<h1>{them.name}</h1>
							<div className="top-sports">
								{them.mySport.map((item, i) => {
									if (i >= 3) {
										return null;
									}
									return (
										<img
											src={item.image}
											className={this.state.activeIndex === i ? "active" : ""}
											key={i}
											onClick={() => {
												this.setState({
													activeIndex: i,
													activeTab: "details",
													activeView: null,
													activeTeam: null
												});
											}}
										/>
									);
								})}
							</div>
							<div className="top-others">
								{yoo.id === -1 && (
									<div
										className={
											this.state.activeView === "add"
												? "top-other-item active"
												: "top-other-item"
										}
										onClick={() => {
											this.setState({
												activeTab: "others",
												activeView: "add",
												activeIndex: null
											});
										}}
									>
										<img src="images/add_wht.svg" />
										<span>Add a sport</span>
									</div>
								)}
								<div
									className={
										this.state.activeView === "sport"
											? "top-other-item active"
											: "top-other-item"
									}
									onClick={() => {
										this.setState({
											activeTab: "others",
											activeView: "sport",
											activeIndex: null
										});
									}}
								>
									<img src="images/like_icon_wht.svg" />
									<span>Sports I like</span>
								</div>
								<div
									className={
										this.state.activeView === "teams"
											? "top-other-item active"
											: "top-other-item"
									}
									onClick={() => {
										this.setState({
											activeTab: "others",
											activeView: "teams",
											activeIndex: null
										});
									}}
								>
									<img src="images/like_icon_wht.svg" />
									<span>Teams I support</span>
								</div>
							</div>
						</div>
						<div className="bottom-section">
							{this.state.activeTab === "details" &&
								them.mySport.length > 0 && (
									<div className="sport-details">
										<div>
											<div className="sport-detail">
												<span>Position</span>
												<span>
													{this.state.activeTeam !== null &&
														this.state.activeTeam.position !== ""
														? this.state.activeTeam.position
														: them.mySport[this.state.activeIndex].stats
															.position}
												</span>
											</div>
											<div className="sport-detail">
												<span>Height</span>
												<span>{them.basicInfo[3].value}</span>
											</div>
											<div className="sport-detail">
												<span>Weight</span>
												<span>{them.basicInfo[4].value}</span>
											</div>
											<div className="sport-detail">
												<span>Age</span>
												<span>{them.age}</span>
											</div>
											<div className="sport-detail">
												<span>D.O.B</span>
												<span>{them.dob}</span>
											</div>
											{teams.length <= 1 && (
												<div className="sport-detail">
													<span>Current Team</span>
													<span>
														{teams.length >= 1 ? teams[0].name : "Not set"}
													</span>
												</div>
											)}
											{teams.length > 1 && (
												<div
													className="sport-detail"
													style={{ alignItems: "flex-start" }}
												>
													<span>Current Team</span>
													<TeamsMiniSlider
														onSetActiveTeam={t =>
															this.setState({ activeTeam: t })
														}
														filter={them.mySport[this.state.activeIndex].name}
														teams={them.myTeams}
													/>
												</div>
											)}
										</div>
										<div>
											<SportGraphChart Content={
												[
													<span key={"one"}>
														{this.getSportGoalTerm(
															them.mySport[this.state.activeIndex].name
														)}
													</span>,
													<div key={"two"}>
														{them.mySport[this.state.activeIndex].stats.goals}
													</div>
												]
											}/>

											<SportGraphChart className={"chart"} Content={
												[
													<span key={"m-one"}>Matches</span>,
													<View key={"m-two"} style={{
														alignItems: 'center',
														justifyContent: 'center',
														flexDirection: 'row'
													}}>
														{them.mySport[this.state.activeIndex].stats.matches}
													</View>
												]
											}/>
											<SportGraphChart className={"chart"} Content={
												[
													<span key={"min-one"}>Minutes</span>,
													<View key={"min-two"} style={{
														alignItems: 'center',
														justifyContent: 'center',
														flexDirection: 'row'
													}}>
														{them.mySport[this.state.activeIndex].stats.minutes}
													</View>
												]
											}/>
											<div className="sport-detail-graph chart">
												
											</div>
										</div>
									</div>
								)}
							{this.state.activeTab === "others" &&
								this.state.activeView === "sport" && (
									<div className="other-details">
										<h3 style={{ width: "100%", color: "#fff" }}>
											Sports I Like
                    </h3>
										{them.sportsFollowed.map((item, i) => {
											return (
												<a key={i}>
													<img className="with-hover" src={item.image} />
												</a>
											);
										})}
									</div>
								)}
							{this.state.activeTab === "others" &&
								this.state.activeView === "teams" && (
									<div className="other-details">
										<h3 style={{ width: "100%", color: "#fff" }}>
											Teams I Follow
                    </h3>
										{them.teamsFollowed.map((item, i) => {
											return (
												<Link to={"/team/" + item.id} key={i}>
													<img src={item.image} />
												</Link>
											);
										})}
									</div>
								)}
							{this.state.activeTab === "others" &&
								this.state.activeView === "add" && (
									<div className="other-details-add">
										{sports.map((item, i) => {
											return (
												<a key={i}>
													{item.image !== null && (
														<img className="with-hover" src={item.image} />
													)}
													<span>{item.name}</span>
												</a>
											);
										})}
									</div>
								)}
						</div>
					</div>
					<div className="profile-banner-main-picture">
						<img src={them.image} />
						{yoo.id === them.id && (
							<div className="back-photo">
								<ChangePictureIcon
									toType="P"
									pictures={this.props.pictures}
									type="background_cover_original"
									idField={"user_id"}
									table={"users"}
									field={"background_cover_original"}
									page="users"
									toId={them.id}
									pictureForType="P"
								/>
							</div>
						)}
						{yoo.id === them.id && (
							<div className="front-photo">
								<ChangePictureIcon
									toType="P"
									pictures={this.props.pictures}
									type="profile_photo"
									idField={"user_id"}
									table={"users"}
									field={"profile_photo"}
									page="users"
									toId={them.id}
									pictureForType="P"
								/>
							</div>
						)}
					</div>
				</div>
				<div
					style={{
						position: "absolute",
						bottom: 0,
						right: 0,
						height: 60,
						marginBottom: 55,
						width: "70%",
						paddingRight: "250px",
						color: "#fff"
					}}
				>
					<div className="action-buttons">
						{!them.isAdmin &&
							!this.state.request.inRequest &&
							!this.state.isFriend &&
							!this.state.isPending && (
								<div
									onClick={() => {
										this.addFriend();
									}}
								>
									<i className="material-icons">person_add</i>Add Friend
                </div>
							)}
						{!them.isAdmin &&
							this.state.request.inRequest &&
							!this.state.isFriend &&
							!this.state.isPending && (
								<div
									onClick={() => {
										this.acceptThem()
									}}
								>
									<i className="material-icons">person_add</i>Accept Friend
                </div>
							)}
						{!them.isAdmin &&
							!this.state.isFriend &&
							this.state.isPending && (
								<div
									onClick={() => {
										this.cancelRequest();
									}}
								>
									<i className="material-icons">close</i>Cancel Request
                </div>
							)}
						{!them.isAdmin &&
							this.state.isFriend &&
							!this.state.isPending && (
								<div
									onClick={() => {
										this.setState({ isDeleting: true });
									}}
								>
									<i className="material-icons">close</i>Unfriend
                </div>
							)}
						{!them.isAdmin &&
							this.state.request.inRequest &&
							!this.state.isFriend &&
							!this.state.isPending && (
								<div
									onClick={() => {
										this.setState({ isDeleting: true });
									}}
								>
									<i className="material-icons">delete</i>Remove Request
                </div>
							)}
						{!them.isAdmin &&
							<div onClick={() => {
								const chat = them.convo ? them.convo : {
									otherUser: {
										id: them.id,
										type: "F",
										...them
									},
									id: null,
									userOne: FakeData.getData("yoo"),
									userTwo: {
										id: them.id,
										type: "F",
										...them
									},
									messages: [],
									last_msg: null,
									unread: 0,
									isYou: true,
									date: null,
									removedByUserOne: false,
									removedByUserTwo: false,
									type: "timeline",
									target: "new"
								}

								FakeData.shared("mainThread").addToChats(chat)
							}}><i className="material-icons">chat</i>Message</div>
						}
						{them.isAdmin &&
							<div onClick={() => {
								this.props.onTabSelect(
									{ val: "about", key: "About", notices: [] }
								);
							}}><i className="material-icons">edit</i>Edit Profile</div>
						}

						<div>
							<FeedBackPopUp key={"profile-" + them.id} isBanner={true} userTo={{
								id: FakeData.getData("yoo").id,
								type: "F"
							}} user={{
								id: them.id,
								type: "F"
							}} object={{
								id: them.id,
								type: "F",
								content: them.name,
								image: them.image
							}} owner={{
								id: them.id,
								type: "F",
								name: them.name,
								user: them.username,
								image: them.image,
								email: them.email
							}} text={"More"} iconStyle={{
								margin: "0px 0px 0px 10px",
							}} icon={"more_horiz"} style={{
								display: 'flex'
							}} menus={them.isAdmin ?
								{
									Setting: {
										label: "Timeline Settings", cb: () => {
											this.props.onTabSelect(
												{ val: "settings", key: "Settings", notices: [] }
											);
										}
									}
								} : {
									FeedBack: { label: "Report Profile", cb: () => { } },
									Block: { label: "Block", cb: () => { } }
								}} />
						</div>
					</div>
				</div>
				<div className="profile-banner-nav">
					{this.props.tabs.map((item, i) => {
						if (
							FakeData.inArray(item.val, [
								"notice",
								"training",
								"events",
								"settings"
							]) &&
							!this.props.profile.isAdmin
						) {
							return null;
						}
						const notices = {};
						return (
							<div
								key={i}
								className={item.val === this.props.activeTab ? "active" : ""}
								onClick={() => {
									this.props.onTabSelect(item);
								}}
							>
								{item.key}
								{item.notices.length > 0 &&
									this.props.profile.isAdmin && (
										<div className="notices-badge">
											{this.getFilteredNotices(
												["event_invite", "event_admin_invite", "event_accept"],
												item.notices
											).length > 0 && (
													<span className="events">
														{
															this.getFilteredNotices(
																[
																	"event_invite",
																	"event_admin_invite",
																	"event_accept"
																],
																item.notices
															).length
														}
													</span>
												)}
											{this.getFilteredNotices([], item.notices).length > 0 && (
												<span className="_training">
													{this.getFilteredNotices([], item.notices).length}
												</span>
											)}
											{this.getFilteredNotices(
												["game_invite", "game_accept"],
												item.notices
											).length > 0 && (
													<span className="games">
														{
															this.getFilteredNotices(
																["game_invite", "game_accept"],
																item.notices
															).length
														}
													</span>
												)}
											<span className="all">{item.notices.length}</span>
										</div>
									)}
							</div>
						);
					})}
				</div>
				{this.state.isDeleting && (
					<ConfirmModal
						message="Are you sure you want to remove this person as your friend?<br/>"
						isOpen={this.state.isDeleting}
						data={""}
						onOkay={() => {
							if (this.state.request.inRequest) {
								this.cancelRequest(this.state.request.yourCancelID);
							} else {
								this.remove();
							}
						}}
						onCancel={() => {
							this.setState({
								isDeleting: false
							});
						}}
					/>
				)}
			</div>
		);
	}
}

const SportGraphChart = ({Content, className, ...props}) => {
	return(
		<View className={`sport-detail-graph ${className}`} style={{
			alignItems: 'center',
			justifyContent: 'center',
		}}>{Content}</View>
	)
}

class TeamsMiniSlider extends Component {
	constructor(p) {
		super(p);
		this.state = {
			active: {}
		};
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.filter !== nextProps.filter) {
			this.setState({
				active: {}
			});
		}
	}

	getTeams() {
		const arr = [];
		this.props.teams.forEach((item, i) => {
			if (item.sport === this.props.filter) {
				arr.push(item);
			}
		});

		return arr;
	}

	render() {
		const teams = this.getTeams();
		return (
			<div className="teams-min-slider">
				<span>
					{this.state.active.id ? this.state.active.name : teams[0].name}
				</span>
				<div className="teams-min-slider-dots">
					{teams.map((item, i) => {
						return (
							<span
								key={i}
								className={
									this.state.active.id && this.state.active.id === item.id
										? "active"
										: ""
								}
								onClick={() => {
									this.setState({
										active: item
									});
									this.props.onSetActiveTeam(item);
								}}
							/>
						);
					})}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/Profile.js